module.exports = __webpack_public_path__ + "img/fotet_btn.1f6f6461.png";